// Lowercases a string, returning undefined for any non-string (null-safe).
const toLower = value => (typeof value === 'string' ? value.toLowerCase() : undefined);

export default toLower;
